import React, { TextareaHTMLAttributes } from 'react'

import { useField } from 'formik'
import classNames from 'classnames'

import { FieldError } from '@components/form'
import { FieldProps } from '@components/form/types'

import styles from '../styles.module.scss'

type TextAreaProps = FieldProps & TextareaHTMLAttributes<HTMLTextAreaElement>

export const TextArea = ({
  name,
  label,
  className,
  container,
  error,
  withoutError = false,
  ...rest
}: TextAreaProps) => {
  const [field, meta] = useField<string>(name)

  return (
    <div {...container} className="flex flex-col">
      {label}
      <textarea
        className={classNames(styles.input, className, {
          [styles.error]: meta.error && meta.touched
        })}
        {...field}
        {...rest}
      />
      {!withoutError && (
        <FieldError touched={meta.touched} error={meta.error} {...error} />
      )}
    </div>
  )
}
